<template>
    <div>
        <div class="modal modal-nopadding modal-80 flex"
             :style="{zIndex:zIndex}" v-show="config.show" transition="fade">
            <div class="modal-backdrop in" @click="close()"></div>
            <div class="modal-dialog" style="width:900px">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click.stop="config.show = false;"></button>
                        <h4 class="modal-title">选择图片</h4>
                    </div>
                    <div class="modal-body">
                        <div class="hbox">
                            <aside class="aside">
                                <ul class="list-group swm_side">
                                    <li class="list-group-item"
                                        :class="{
                                            'current': !currentGroup
                                        }"
                                        @click="selectGroup(null)"> <a href="javascript:void(0)">全部</a>
                                      <!--<span class="badge badge-default"> 32 </span>-->
                                    </li>
                                    <li class="list-group-item"
                                        :class="{
                                            'current': currentGroup && 'ungroup' === currentGroup.objectId
                                        }"
                                        @click="selectGroup({objectId: 'ungroup'});"> <a href="javascript:void(0)">未分组</a>
                                      <!--<span class="badge badge-default"> 32 </span>-->
                                    </li>
                                    <template v-for="g in groups">
                                      <li class="list-group-item"
                                          :class="{
                                            'current': currentGroup && g.objectId === currentGroup.objectId
                                          }"
                                          @click="selectGroup(g)">
                                          <a href="javascript:void(0)"> {{g.title}} </a>
                                      </li>
                                    </template>
                                </ul>
                            </aside>
                            <section class="material-img-list project-list clearfix">
                                <div class="bg-grey-cararra padding-10 ovh-imp">
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <!--<form class="form-inline">
                                                <div class="input-group input-group-sm">
                                                    <input type="text" class="form-control" placeholder="搜索关键字" name="query" style="width:240px;">
                                                </div>
                                                <button type="submit" class="btn red btn-sm" >
                                                    <i class="icon-magnifier"></i> 搜索</button>
                                            </form>-->
                                        </div>
                                        <div class="col-sm-4">
                                            <!--<button type="button"
                                                class="btn red btn-sm pull-right"
                                                @click="showCreate = true;"> <i class="fa fa-plus"></i> 添加图片 </button>-->

                                            <button type="button" class="btn m-green btn-sm pull-right" style="position:relative;">
                                              <i class="fa fa-plus"></i> 本地上传 <!--@click="showCreate = true;"-->
                                              <input type="file" name="files[]" data-role="mulFile"
                                                     multiple
                                                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;opacity: 0;"/>
                                            </button>

                                            <div v-show="loading" class="pull-right">
                                              <img src="../assets/global/img/input-spinner.gif" /> 上传中，请稍后...
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <section class="win-list win-video-list" style="height:475px;">
                                    <div class="row gutter-5">
                                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2"
                                            v-for="it in list">
                                            <div class="item" style="height:auto"
                                                :class="{
                                                    'active' : current && it.objectId === current.objectId
                                                }"
                                                @click="select(it)"
                                                @dblclick="dbClick(it)">
                                                <h5>{{it.title}}</h5>
                                                <div class="img-rect-wrap">
                                                    <div class="img-rect">
                                                        <div class="img-wrap">
                                                            <img :src="it.imgUrl" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--<div class="">作者：{{it.authorName}}</div>-->
                                                <div class="item-overlay"
                                                    :class="{
                                                            'checked': current && it.objectId === current.objectId
                                                        }">
                                                    <a href="javascript:void(0);" class="view-icon">
                                                        <i class="fa fa-square-o"></i>
                                                        <i class="fa fa-check-square-o"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pull-right padding-right-10">
                                        <c-pagination :pagination-conf="paginationConf"></c-pagination>
                                    </div>
                                </section>
                            </section>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn m-white" @click.stop="close()">取消</button>
                        <button type="button" class="btn m-green" @click.stop="ok()">确定</button>
                    </div>
                </div>
            </div>
        </div>

        <c-modal :show.sync="showCreate" class="modal-nopadding">
            <h4 class="modal-title" slot="title">添加图片</h4>
            <c-image-create v-on:image-create-cancel="this.showCreate=false"></c-image-create>
            <div slot="footer"></div>
        </c-modal>
    </div>
</template>
<style>

  .modal.flex{
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
  }
</style>
<script>
import $ from 'jquery';
import { mapState, mapActions } from 'vuex';
import cPagination from './pagination';
import cImageCreate from '../views/material/image-create';
import cModal from './modal';

export default {
    data() {
        let vm = this;
        return {
            showCreate: false,
            showGroupCreate: false,
            loading: false,
            currentGroup: null,
            //title: '',
            list: [],
            current: null,
            zIndex: 0,
            paginationConf : {
                currentNo: 1,
                totalRecords: 0,
                showNum: 7,
                pageSize: 18,
                onChange: function(){
                    var self = this;
                    $.ajax('/api/web/material/img/list', $.extend(true, {}, {
                          dataType : 'json',
                          data : {
                            gid: (vm.currentGroup && vm.currentGroup.objectId),
                            page : self.currentNo,
                            pageSize: self.pageSize
                          }
                    }))
                    .done(function(data, status, jqXhr){
                        vm.list = data.data.list;
                        self.totalRecords = data.data.total || 0;
                        vm.loaded = 1;
                    })
                    .fail(function(jqXhr, status, e){
                        vm.loaded = 2;
                    });
                }
            }
        }
    },
    mounted() {
        let self = this;
        $(this.$el).on('change', 'input[data-role=mulFile]', function(){

            self.loading = true;
            let $f = $(this);
            let $c = $(this).clone();
            $.ajaxFileUpload({
                url : '/api/web/material/upload',
                secureuri : false,
                timeout: 1000*60*2,
                fileElementId : $f,
                data : {
                  gid: (self.currentGroup && self.currentGroup.objectId)
                },
                dataType : 'json',
                success : function(data, status) {
                    self.loading = false;
                    self.paginationConf.onChange();
                    $f.parent().append($c);
                    $f.remove();

                    if(data && data.code === 400 && data.message) {
                        self.showAlert(data.message);
                    }
                },
                error : function(data, status, e) {
                    self.loading = false;
                    self.paginationConf.onChange();
                    $f.parent().append($c);
                    $f.remove();

                    if(data && data.message) {
                        self.showAlert(data.message);
                    }
                }
            })
        })
    },
    components: {
        cPagination,
        cModal,
        cImageCreate
    },
    watch: {
        'config.show': function(val, oldVal) {
            if(val === true) {
                this.current = null;
                this.zIndex = this.maxZIndex;
                this.increaseZIndex();
                this.paginationConf.onChange();
            }
        }
    },
    computed: mapState({
        groups: state => state.groups,
        config: state => state.selectImgWin,
        maxZIndex: state => state.maxZIndex
    }),
    methods: {
        ...mapActions([
            'showAlert',
            'increaseZIndex',
            'showLoading',
            'hideLoading'
        ]),
        ok: function(){
            this.config && this.config.ok && this.config.ok(this.current);
            this.close();
        },
        close: function(){
            this.config.show = false;
        },
        select: function(it){
            if(this.current && it && this.current.objectId === it.objectId) {
                this.current = null;
            } else {
                this.current = it;
            }
        },
        dbClick: function(it) {
          this.select(it)
          this.ok()
        },
        selectGroup: function(g) {
            this.currentGroup = g;
            this.paginationConf.onChange();
        }
    }
}
</script>
